import { VrdhCallReason } from '@/api/types/ProviderApi'
import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import { router } from 'expo-router'

const ScheduleCallButton = ({
	callReason = VrdhCallReason.APPOINTMENT_RESULTS,
}: { callReason?: VrdhCallReason }) => {
	const onBookVrdhCallClick = () => {
		analytics.trackClick('schedule-call-appointment-button')

		router.push({
			pathname: '/schedule-call',
			params: {
				callReason,
			},
		})
	}

	return (
		<Button className="max-w-56" onPress={onBookVrdhCallClick} withArrow>
			<ButtonText>Book a call</ButtonText>
		</Button>
	)
}

export { ScheduleCallButton }
